import React, { useEffect } from 'react';
import { FloatingPopUp } from '../helpers/FloatingPopUp';
import { useFocusPoint } from '../hooks/useFocusPoint';
import {
  NoticeRecord,
  NoticeRecordListItem,
  MaintenanceNoticeRecord,
} from '@/types/api/NoticeRecord';
import { NoticeRecordHistory } from '../flows/NoticeRecordHistory';
import { RawNoticeModal } from '../notices/RawNoticeModal';
import { NoticeRecordModal } from '../notices/NoticeRecordModal';

export type NoticeContextMenuProps = {
  notice: NoticeRecord | MaintenanceNoticeRecord | NoticeRecordListItem | null;
  position: { x: number; y: number } | null;
  onClose?: () => void;
};

export enum NoticeContextMenuViewOption {
  NONE = 'NONE',
  HISTORY = 'HISTORY',
  RAW_NOTICE = 'RAW_NOTICE',
  NOTICE_DETAILS = 'NOTICE_DETAILS',
}

export const NoticeContextMenu: React.FC<NoticeContextMenuProps> = (props) => {
  const popupRef = React.useRef<HTMLDivElement>(null);
  const [viewOption, setViewOption] =
    React.useState<NoticeContextMenuViewOption>(
      NoticeContextMenuViewOption.NONE,
    );
  const focusPoint = useFocusPoint();

  const visible = !!props.notice;
  const handleClickOutside = (event: MouseEvent) => {
    if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
      props?.onClose?.();
    }
  };
  useEffect(() => {
    if (visible) {
      window.addEventListener('click', handleClickOutside);
    }
    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, [visible]);

  const hasPoints = props.notice?.points && props.notice.points.length > 0;

  return (
    <>
      <FloatingPopUp visible={visible} position={props.position}>
        <div ref={popupRef} className="bg-light rounded list-group">
          <div
            className={`list-group-item list-group-item-action${
              hasPoints ? '' : ' disabled'
            }`}
            role={hasPoints ? 'button' : undefined}
            onClick={() => {
              console.log(props.notice);
              if (hasPoints) focusPoint(props.notice?.points?.[0]);
            }}
          >
            Locate
          </div>
          <div
            className={`list-group-item list-group-item-action`}
            role="button"
            onClick={() => {
              setViewOption(NoticeContextMenuViewOption.NOTICE_DETAILS);
            }}
          >
            Details
          </div>
          <div
            className={`list-group-item list-group-item-action`}
            role="button"
            onClick={() => {
              setViewOption(NoticeContextMenuViewOption.HISTORY);
            }}
          >
            History
          </div>
          <div
            className={`list-group-item list-group-item-action`}
            role="button"
            onClick={() => {
              setViewOption(NoticeContextMenuViewOption.RAW_NOTICE);
            }}
          >
            Raw Notice
          </div>
        </div>
      </FloatingPopUp>
      {viewOption === NoticeContextMenuViewOption.HISTORY && (
        <NoticeRecordHistory
          componentId={props.notice?.notice_component ?? ''}
          setHistoryModal={() =>
            setViewOption(NoticeContextMenuViewOption.NONE)
          }
          getFlowsOnDate={() => {}}
        />
      )}
      {viewOption === NoticeContextMenuViewOption.RAW_NOTICE && (
        <RawNoticeModal
          notice={props.notice}
          isOpen={true}
          onClose={() => setViewOption(NoticeContextMenuViewOption.NONE)}
        />
      )}
      {viewOption === NoticeContextMenuViewOption.NOTICE_DETAILS && (
        <NoticeRecordModal
          noticeRecordId={props.notice?.id}
          isOpen={true}
          onClose={() => setViewOption(NoticeContextMenuViewOption.NONE)}
        />
      )}
    </>
  );
};
